export default __webpack_public_path__ + "static/media/js.dd77c863.png";